/**
 * PreviewPoolSelect — compact dropdown scoping the preview lists to one path
 * allocation pool (default paths / conditional group / Binom rule). Hidden
 * when the flow has a single pool. A dropdown (not pills) because flows can
 * carry dozens of pools.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';
import type { FlowOptimizerPool } from '@trafficpulse/shared';

const ALL_POOLS = '__all__';

export interface PreviewPoolSelectProps {
  pools: ReadonlyArray<FlowOptimizerPool>;
  value: string | null;
  onChange: (pool: string | null) => void;
}

const PreviewPoolSelect: FC<PreviewPoolSelectProps> = ({
  pools,
  value,
  onChange,
}) => {
  if (pools.length < 2) return null;
  return (
    <div className="flex min-w-0 items-center gap-1">
      <span className="text-[9px] font-medium uppercase tracking-wide text-muted-foreground">
        Pool
      </span>
      <select
        aria-label="Filter preview by path pool"
        value={value ?? ALL_POOLS}
        onChange={(e) =>
          onChange(e.target.value === ALL_POOLS ? null : e.target.value)
        }
        className="h-6 min-w-0 max-w-[11rem] truncate rounded border border-border/60 bg-background px-1.5 text-[10px] text-foreground hover:bg-muted/40 focus:outline-none focus:ring-1 focus:ring-primary/40"
      >
        <option value={ALL_POOLS}>All pools</option>
        {pools.map((pool) => (
          <option key={pool.id} value={pool.id}>
            {pool.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default PreviewPoolSelect;
